/** Ouvre le calendrier ou l'horloge natifs au clic sur le champ. */
export function openNativePicker(event: React.MouseEvent<HTMLInputElement>) {
  const input = event.currentTarget;
  try {
    if ("showPicker" in input) input.showPicker();
  } catch {
    // Le sélecteur est déjà ouvert, ou le navigateur refuse l'appel.
  }
}
